import React from 'react';
import {Link} from "react-router-dom";
import "./TopMenu.scss";

function TopMenu() {
    const contactForm = "b451d86b-6b2e-4302-9955-2dbaf11c3843";

    return (
        <div className="top-menu">
            <Link to={{pathname: `/`}}>Scripts</Link>
            <Link to={{pathname: `/info`}}>Info</Link>
            {contactForm ? <Link to={{pathname: `/contact`}}>Contact</Link> : null}
            <a className="subscribe" href="https://www.youtube.com/channel/UCc7ovfgzus_aK3SdVIB01Dw" target="_blank" rel="noreferrer">Subscribe</a>
        </div>
    );
}

export default TopMenu;
